import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import FloatingAIChat from './components/FloatingAIChat';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import PatientsPage from './pages/PatientsPage';
import PatientProfilePage from './pages/PatientProfilePage';
import AppointmentsPage from './pages/AppointmentsPage';
import ConsultationPage from './pages/ConsultationPage';
import PrescriptionPage from './pages/PrescriptionPage';
import DiabetesPage from './pages/DiabetesPage';
import NutritionPage from './pages/NutritionPage';
import RenalPage from './pages/RenalPage';
import SettingsPage from './pages/SettingsPage';
import StatsPage from './pages/StatsPage';

function Spinner() {
  return (
    <div className="flex items-center justify-center h-screen bg-stone-50">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-emerald-600"></div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppContent() {
  const { user } = useAuth();
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="patients" element={<PatientsPage />} />
          <Route path="patients/:id" element={<PatientProfilePage />} />
          <Route path="appointments" element={<AppointmentsPage />} />
          <Route path="consultations/new" element={<ConsultationPage />} />
          <Route path="consultations/:id" element={<ConsultationPage />} />
          <Route path="prescriptions" element={<PrescriptionPage />} />
          <Route path="diabetes" element={<DiabetesPage />} />
          <Route path="nutrition" element={<NutritionPage />} />
          <Route path="renal" element={<RenalPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="stats" element={<StatsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      {user && user !== false && <FloatingAIChat />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
